import Vue from 'vue'
import SafePhone from '~/components/common/SafePhone.vue'

Vue.component('SafePhone', SafePhone)
